import axios from 'axios';

const BASE_URL = process.env.VUE_APP_API_URL;

export const apiClient = axios.create({
  baseURL: `${BASE_URL}`,
  withCredentials: true, // To get CSRF from cookie
  validateStatus(status) {
    return status >= 200 && status < 500; // default
  },

});



apiClient.interceptors.request.use(
  async (conf) => {
    const token = localStorage.getItem('token');
    if (token) {
      conf.headers.Authorization = `Bearer ${token}`;
    }
    return conf;
  },
  (error) => {
    return Promise.reject(error.response);
  },
);

apiClient.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (error.response.status === 401) {
      // TODO: log out
    }

    return Promise.reject(error.response);
  },
);
